import List from 'containers/MarketingMetrics';

export default { List };
